import React from "react";

export default function ForecastChartLoader() {
  return (
    <div className="w-full h-72 bg-black bg-opacity-80 animate-pulse"></div>
  );
}
